import { createPageApp } from '@/lib/createPageApp'
import RequiresPurchasePage from './RequiresPurchasePage.vue'

createPageApp(RequiresPurchasePage).mount()
